export function StatCard({ label, value, subtext, accent = false }: { label: string; value: string; subtext: string; accent?: boolean }) {
  return <article className={`flex min-h-36 flex-col justify-center rounded-2xl border p-5 ${accent ? "border-indigo-500 bg-indigo-500 text-white" : "border-zinc-200 bg-white text-zinc-950"}`}>
    <h2 className={`text-sm font-semibold ${accent ? "text-indigo-50" : "text-zinc-700"}`}>{label}</h2>
    <strong className="mt-2 font-mono text-3xl font-semibold tracking-tight">{value}</strong>
    <p className={`mt-1 text-sm ${accent ? "text-indigo-100" : "text-zinc-500"}`}>{subtext}</p>
  </article>;
}
